import { styled } from '@mui/material/styles';
import { Box, Stack } from "@mui/material";

import { APP_BAR_HEIGHT } from '../sticky-nav/sticky-nav.const';

export const StyledBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
});

export const StyledImage = styled('img')({
  aspectRatio: '1/1',
  maxWidth: '550px',
  width: '88vw',
});

export const StyledStack = styled(Stack)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '32px 0',
  width: '100%',
});
